import React from "react";
import "./style.scss";
import OrderSummary from "../../../components/Dashboard/OrderSummary";
const OrderSummaryPage = () => {
  return (
    <div className="order_summary_page_wrapper">
      <OrderSummary />
    </div>
  );
};
export default OrderSummaryPage;
